import { PickersLayout } from "@mui/x-date-pickers";
import { TimeViewWithMeridiem } from "@mui/x-date-pickers/internals";
import { Dayjs } from "dayjs";
import { styled } from "@mui/material";

export const StyledTimePickerLayout = styled(
  PickersLayout<Dayjs | null, Dayjs, TimeViewWithMeridiem>,
)`
  ${({ theme: { wsc } }) => `
    border-radius: ${wsc.radius.m};
    color: ${wsc.palette.neutral[100]};
    border: calc(${wsc.spacing[0]} / 4) solid ${wsc.palette.neutral[600]};
    background-color: ${wsc.palette.neutral[700]};
    padding: ${wsc.spacing[2]};
  `};

  .MuiMultiSectionDigitalClockSection-root {
    ::-webkit-scrollbar-thumb {
      background: ${({ theme: { wsc } }) => wsc.palette.neutral[600]};
    }

    &:not(:first-child) {
      ${({ theme: { wsc } }) => `
        padding-left: ${wsc.spacing[0]};
        border-left: calc(${wsc.spacing[0]} / 4) solid
        ${wsc.palette.neutral[500]};
        margin-left: calc(${wsc.spacing[0]} / 2);
    `};
    }

    &:last-child {
      padding-right: calc(${({ theme: { wsc } }) => wsc.spacing[3]} / 4);
    }

    scrollbar-gutter: stable;
    padding-right: calc(${({ theme: { wsc } }) => wsc.spacing[3]} / 2);
    width: fit-content;

    .MuiMultiSectionDigitalClockSection-item {
      ${({ theme }) => theme.wsc.typography.header5};

      ${({ theme: { wsc } }) => `        
      border-radius: ${wsc.radius.m};
      padding: ${wsc.spacing[1]};
      margin: 0 0 ${wsc.spacing[0]};
      color: ${wsc.palette.neutral[100]};

      &.Mui-selected {
        background-color: ${wsc.palette.primary[300]};
        color: ${wsc.palette.neutral[700]};
      }
        
      &.Mui-selected:hover {
        background-color: ${wsc.palette.primary[300]};
      }

      &:hover {
        background-color: ${wsc.palette.neutral[600]};
      }  `};
    }
  }

  .MuiPickersLayout-actionBar {
    padding: 0;

    & button {
      display: inline-block;
      ${({ theme: { wsc } }) => `       
      margin-top: ${wsc.spacing[2]};
      background-color: ${wsc.palette.primary[300]};
      color: ${wsc.palette.neutral[600]};
      padding: ${wsc.spacing[1]};
      border-radius: ${wsc.radius.m};`};
      text-transform: lowercase;
      ${({ theme }) => theme.wsc.typography.button};

      &::first-letter {
        text-transform: uppercase;
      }
    }
  }

  .MuiMultiSectionDigitalClock-root {
    border: 0;
  }
`;
